import React, { useEffect, useState } from 'react'
import { GoAlert } from "react-icons/go"
import Subestacion from "./Subestacion1.js"
import Subestacion2 from "./Subestacion2.js"
import './Subestacion.css';

function VerSubestacion() {


    var [subestacion, setSubestacion] = useState([]);
    var [data, setData] = useState([]);

    /*Sirve para que las llamadas no se acumulen al cambiar de ventana  */
    var [code, setCode] = useState(null);
    if (code == null) {
        let valor = parseInt(sessionStorage.getItem('key')) + 1;
        setCode(valor);
        sessionStorage.setItem("key", valor)
    }

    let number = 0;
    useEffect(() => {
        fetch(window.location.protocol + "//" + window.location.hostname + "/api" + "/lastData/substationStatus", { method: 'GET', credentials: 'include' })
            .then(async (dataSubestacion) => { setSubestacion(await dataSubestacion.json()); })
            .catch(e => { console.log(e); })
        var interval1 = setInterval(function () {
            number++;
            if (code === sessionStorage.getItem("key")) { // No ha cambiado de página
                fetch(window.location.protocol + "//" + window.location.hostname + "/api" + "/lastData/substationStatus", { method: 'GET', credentials: 'include' })
                    .then(async (dataSubestacion) => { setSubestacion(await dataSubestacion.json()); })
                    .catch(e => { console.log(e); })
            } else { //Ha cambiado de página. Cancela bucle
                clearInterval(interval1);
            }
        }, 30000)
    }, [number]);

    //dividimos los estados de los componentes de la subestacion segun el trafo al que pertenecen
    var subestacion = [];
    for (let i = 0; i < subestacion.length; i++) {
        subestacion = [...subestacion, subestacion[i]]
    }

    //dividimos los datos de la subestacion segun el trafo al que pertenecen
    var data = [];
    for (let i = 0; i < data.length; i++) {
        data = [...data, data[i]]
    }

/*
    if (subestacion.length > 0 || subestacion.length < 1) {
        var actualizados = subestacion[0].updated;
        var fecha = subestacion[0].timeStamp;
    }
*/
    return (
        <div className='container-flex containerSubestacion'>
            <div className='row' id="row-subestacion" style={{ maxHeight: "100%",maxWidth:"100%", overflow: "auto" }}>
                {<Subestacion2 svgData={subestacion} data={data}/> }
            </div>
        </div>
    )
}

export default VerSubestacion